import styled from 'styled-components';
import { theme } from '../../styles/theme';

const ScrollableContainer = styled.div<{ $scrollWidth?: number }>`
  flex: 1;
  min-height: 0;
  width: 100%;
  height: 100%;
  position: relative;
  outline: none;
  overflow-y: auto;
  overflow-x: auto;
  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar {
    width: ${({ $scrollWidth }) => $scrollWidth || 4}px;
    height: ${({ $scrollWidth }) => $scrollWidth || 4}px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: ${({ $scrollWidth }) => $scrollWidth || 4}px;
    transition: background-color 0.2s;
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.secondary400};
  }
`;

interface ScrollableWrapperProps {
  children: React.ReactNode;
  className?: string;
  scrollWidth?: number;
}

const ScrollableWrapper = ({
  children,
  scrollWidth = 4,
  className,
}: ScrollableWrapperProps) => {
  return (
    <ScrollableContainer $scrollWidth={scrollWidth} className={className}>
      {children}
    </ScrollableContainer>
  );
};

export default ScrollableWrapper;
